<div class="container">
  <h2 class="content-block">Blog</h2>
  <div class="content-block responsive-paddings">
    <h6 class="m-3">Not:Genişlik 600px, yükseklik 400px olacak şekilde resim ekleyiniz</h6> 
    <dx-data-grid
      [dataSource]="dataSource"
      keyExpr="id"
      class="content-block card responsive-paddings"
      style="padding-top:33px;"
      (onRowInserting)="createBlog($event)"
      (onRowUpdating)="updateBlog($event)"
      (onRowRemoved)="deleteBlog($event)"
      (onInitNewRow)="onInitNewRow($event)"
    >
      <dxo-editing
        mode="popup"
        [allowUpdating]="true"
        [allowDeleting]="true"
        [allowAdding]="true"
      >
      </dxo-editing>
      <dxo-export [enabled]="false"></dxo-export>
      <dxi-column dataField="title" caption="Başlık">
        <dxi-validation-rule
          type="required"
          message="Name is required"
        ></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="tag" caption="Etiket" [visible]="false">
      </dxi-column>
      <dxi-column
        dataField="metaKeyword"
        caption="metaKeyword"
        [visible]="false"
      >
      <dxi-validation-rule
      type="required"
      message="Meta Keyword is required"
    ></dxi-validation-rule>
      </dxi-column>
      <dxi-column
        dataField="metaDescription"
        caption="metaDescription"
        [visible]="false"
      >
      <dxi-validation-rule
      type="required"
      message="Meta Description is required"
    ></dxi-validation-rule>
      </dxi-column>

      <dxi-column
        dataField="imageUrl"
        caption="Resim"
        [visible]="true"
        cellTemplate="rowTemplateImageUrl"
        [visible]="true"
        [allowEditing]="false"
      >
      </dxi-column>

      <dxi-column
        dataField="isWebSiteList"
        caption="Yayınla"
        dataType="boolean"
      >
      </dxi-column>
      <dxi-column
        dataField="content"
        caption="İçerik"
        [visible]="false"
        cellTemplate="rowTemplateContent"
      >
        <dxi-validation-rule
          type="required"
          message="Body is required"
        ></dxi-validation-rule>
        <dxo-form-item
          [colSpan]="2"
          editorType="dxHtmlEditor"
          [editorOptions]="editorOptions"
        >
        </dxo-form-item>
      </dxi-column>
      <div
        *dxTemplate="let rowData of 'rowTemplateImageUrl'"
        class="name-template"
      >
        <div>
          <app-image-uploader
            (fileSelected)="onFileSelected($event, rowData.data)"
            [src]="rowData.data.imageUrl"
          ></app-image-uploader>
        </div>
      </div>
    </dx-data-grid>
  </div>
</div>
<!-- <dx-popup
  [showTitle]="true"
  title="Ön izleme"
  [(visible)]="popupVisible"
  [showCloseButton]="true"
>
  <h3></h3>
  <div >Ön İzleme</div>
</dx-popup> -->
